const config = {
  // API Configuration
  callUrl: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? "http://localhost/api" : undefined),
  gameUrl: process.env.REACT_APP_GAME_URL || (process.env.NODE_ENV === 'development' ? "http://localhost:3001/game-screen" : undefined),
  // reCAPTCHA Configuration  
  rcSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || (process.env.NODE_ENV === 'development' ? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" : undefined),
  // API Settings
  apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
  retryAttempts: parseInt(process.env.REACT_APP_RETRY_ATTEMPTS) || 3,
  // Cache Configuration
  cacheConfig: {
    categoriesExpiry: 10 * 60 * 1000, // 10 minutes
    gamesExpiry: 5 * 60 * 1000, // 5 minutes
  },
  // Feature Flags
  features: {
    enableCache: process.env.REACT_APP_ENABLE_CACHE === 'true',
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    enableDebug: process.env.REACT_APP_ENABLE_DEBUG === 'true',
  },
  // Environment Detection
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};
console.log('Environment:', process.env.NODE_ENV);
console.log('API URL:', config.callUrl);
console.log('Game URL:', config.gameUrl);
console.log('Features:', config.features);
module.exports = config;
